import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Input, LOCALE_ID, OnInit, ViewChild } from "@angular/core";
import { MatDatepicker } from "@angular/material/datepicker";
import { FilterCalendarHeaderComponent } from "@sharedV11/components/filter-calendar-header/filter-calendar-header.component";
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";

const MY_FORMATS = {
  parse: { dateInput: "DD/MM/YYYY" },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
import { Mode } from "@sharedV11/classes/tarifas/grupostarifas";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { GlobalService } from "@sharedV11/services/global/global.service";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { getLocale } from "@sharedV11/utils/factories";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { takeUntil, first, debounceTime, distinctUntilChanged } from "rxjs/operators";
import moment from "moment";

type MesInfo = { mes: string; anio: number; mesNum: number; label: string };

interface PreviewLeyendaItem {
  pkId: string;
  nombre: string;
  colorCss: string;
  porDefecto: boolean;
  /** Fechas ISO (vista previa API) para filtrar por meses visibles en el calendario. */
  fechasPreview: string[];
  /** Hay otra temporada en la leyenda visible con el mismo color CSS (normalizado). */
  leyendaMismoColorQueOtra?: boolean;
  /** 1–5: patrón en el cuadrado de muestra; 0 o ausente = sin patrón extra. */
  leyendaVarianteSwatch?: number;
}

@Component({
  selector: "app-edit-temporada-tarifas",
  templateUrl: "./edit-temporada-tarifas.component.html",
  styleUrls: ["./edit-temporada-tarifas.component.scss"],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: getLocale,
      deps: [Translator],
    },
    {
      provide: MAT_DATE_LOCALE,
      useFactory: getLocale,
      deps: [Translator],
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EditTemporadaTarifasComponent implements OnInit, AfterViewInit {
  private static readonly _MESES_LABELS_ES = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
  ];
  private static readonly _MIN_PICKER_YEAR = 1;
  private static readonly _MAX_PICKER_YEAR = 9999;

  loading = true;
  private ngUnsubscribe = new Subject();

  @Input() pkId: string;
  @Input() mode: Mode;
  @Input() modificar: boolean;

  editTemporadaForm: FormGroup;
  translation: any;

 
  private _fechasTemporadaOriginales: { inicio: string; fin: string } | null = null;

  obligarMotivoModificacionAppConfig = false;

  readonly coresDisponiveis: Array<{ value: string; label: string; labelKey: string; hex: string }> = [
    { value: "Blue", label: "Blue", labelKey: "ColorPalette_Blue", hex: "#0000ff" },
    { value: "Red", label: "Red", labelKey: "ColorPalette_Red", hex: "#ff0000" },
    { value: "Green", label: "Green", labelKey: "ColorPalette_Green", hex: "#008000" },
    { value: "Yellow", label: "Yellow", labelKey: "ColorPalette_Yellow", hex: "#ffff00" },
    { value: "Orange", label: "Orange", labelKey: "ColorPalette_Orange", hex: "#ffa500" },
    { value: "Pink", label: "Pink", labelKey: "ColorPalette_Pink", hex: "#ffc0cb" },
    { value: "Brown", label: "Brown", labelKey: "ColorPalette_Brown", hex: "#a52a2a" },
    { value: "Black", label: "Black", labelKey: "ColorPalette_Black", hex: "#000000" },
    { value: "Gray", label: "Gray", labelKey: "ColorPalette_Gray", hex: "#808080" },
    { value: "Purple", label: "Purple", labelKey: "ColorPalette_Purple", hex: "#800080" },
    { value: "Navy", label: "Navy", labelKey: "ColorPalette_Navy", hex: "#000080" },
    { value: "Teal", label: "Teal", labelKey: "ColorPalette_Teal", hex: "#008080" },
    { value: "Cyan", label: "Cyan", labelKey: "ColorPalette_Cyan", hex: "#00ffff" },
    { value: "Olive", label: "Olive", labelKey: "ColorPalette_Olive", hex: "#808000" },
    { value: "LawnGreen", label: "LawnGreen", labelKey: "ColorPalette_LawnGreen", hex: "#7cfc00" },
    { value: "Coral", label: "Coral", labelKey: "ColorPalette_Coral", hex: "#ff7f50" },
    { value: "Indigo", label: "Indigo", labelKey: "ColorPalette_Indigo", hex: "#4b0082" },
    { value: "Maroon", label: "Maroon", labelKey: "ColorPalette_Maroon", hex: "#800000" },
    { value: "SteelBlue", label: "SteelBlue", labelKey: "ColorPalette_SteelBlue", hex: "#4682b4" },
    { value: "SlateGray", label: "SlateGray", labelKey: "ColorPalette_SlateGray", hex: "#708090" },
  ];
  private readonly _colorNameToHex: Record<string, string> = {
    ...this.coresDisponiveis.reduce(
      (acc, c) => {
        acc[c.value.toLowerCase()] = c.hex;
        return acc;
      },
      {} as Record<string, string>
    ),

    white: "#ffffff",
    grey: "#808080",
    gold: "#ffd700",
    sky: "#29b6f6",
    wine: "#880e4f",
    slate: "#546e7a",
    amber: "#ff8f00",
    lime: "#c0ca33",
    turquoise: "#26a69a",
    crimson: "#dc143c",
    tomato: "#ff6347",
    magenta: "#ff00ff",
    deeppink: "#ff1493",
    slateblue: "#6a5acd",
    darkgray: "#a9a9a9",
  };

  /** Regex para código hex válido: #RGB, #RRGGBB ou #RRGGBBAA */
  private static readonly HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;

  static hexOrNamedColorValidator(control: AbstractControl): ValidationErrors | null {
    const v = (control.value ?? "").toString().trim();
    if (!v) return null;
    if (v.startsWith("#")) {
      return EditTemporadaTarifasComponent.HEX_COLOR_REGEX.test(v) ? null : { invalidHexColor: true };
    }
    return null;
  }

  /** Secuencias prohibidas en Descripción (bloqueadas por la API). */
  private static readonly DESCRIPCION_PROHIBIDAS = ['--', ';', '/*', '*/', '@@'];

  static descripcionCaracteresProhibidosValidator(control: AbstractControl): ValidationErrors | null {
    const v = (control.value ?? "").toString();
    if (!v) return null;
    const encontrado = EditTemporadaTarifasComponent.DESCRIPCION_PROHIBIDAS.find((seq) => v.includes(seq));
    return encontrado ? { descripcionCaracteresProhibidos: { secuencia: encontrado } } : null;
  }

  /** Elimina del texto las secuencias prohibidas por la API en Descripción. */
  static sanitizarDescripcion(valor: string): string {
    let s = (valor ?? "").toString();
    EditTemporadaTarifasComponent.DESCRIPCION_PROHIBIDAS.forEach((seq) => {
      s = s.split(seq).join("");
    });
    return s;
  }

  centrosSinAsignar = [];
  centrosAsignados = [];
  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };

  listadoDias: string[] = [];
  private listadoDiasSet: Set<string> = new Set();
  mesesEntreFechas: MesInfo[] = [];
  mesesDoAnoVigente: MesInfo[] = [];
  useStaticColorForTest = false;
  private _cachedColorParaCalendario: string = "#0000ff";
  private isDraggingColor = false;
  @ViewChild("calendariosRoot") private calendariosRoot?: ElementRef<HTMLElement>;
  @ViewChild("pickerInicio") private pickerInicio?: MatDatepicker<Date>;
  @ViewChild("pickerFin") private pickerFin?: MatDatepicker<Date>;

  /** Cabeçalho do datepicker (Anos / Meses / Dias) com paginação ampla, como no filtro de tabelas. */
  readonly filterCalendarHeader = FilterCalendarHeaderComponent;
  mesesSeleccionados: Set<string> = new Set();
  mesVisControls: Record<string, FormControl> = {};
  diasOcupados: Set<string> = new Set();
  loadingOcupados = false;
  /** Modo alta (I): fecha ISO → color CSS desde GetTemporadaTarifas (listadoDias + Color). */
  previewColorPorFecha: Map<string, string> = new Map();
  /** Modo alta (I): fecha ISO → si el día mostrado es de temporada por defecto (leyenda / estrella en celda). */
  previewPorDefectoPorFecha: Map<string, boolean> = new Map();
  /** Modo alta (I): fecha ISO → pkId que gana ese día (mismo criterio que el color en celda; último pkId en orden ascendente). */
  previewPkPorFecha: Map<string, string> = new Map();
  /** Modo alta (I): pkId → nombre de temporada (para etiqueta de 3 letras en celda cuando hay colisión de color). */
  previewNombrePorPk: Map<string, string> = new Map();
  /** Modo alta (I): pkId → variante visual 0–5 (misma regla que la leyenda si hay color repetido). */
  previewVariantePorPk: Map<string, number> = new Map();
  /** Leyenda bajo el calendario: temporadas con al menos un día en vista previa (filtrada por meses visibles). */
  previewLeyenda: PreviewLeyendaItem[] = [];
  /** Lista completa desde la API; la leyenda visible es `previewLeyenda` (filtrada por meses en pantalla). */
  previewLeyendaFuente: PreviewLeyendaItem[] = [];
  loadingPreviewTemporadas = false;
  /** Claves de color (normalizadas) que aparecen en ≥2 temporadas en la leyenda visible (celdas muestran prefijo del nombre). */
  private _coloresDuplicadosEnLeyendaVisible = new Set<string>();
  private anoVigenteCache: number | null = null;
  /** Modo alta: referência da janela visual de 15 meses (mês anterior ao atual ao abrir). */
  private vista15MesesInicio: moment.Moment | null = null;
  private _chavesMesesStr: string | null = null;
  private calendarioTouched = false;
  
  private diasDelMesCache: Map<string, number[]> = new Map();
  private diaOffsetCache: Map<string, number> = new Map();
  private fechaFormatCache: Map<string, string> = new Map();

  private rangoFechaInicioIso: string | null = null;
  private rangoFechaFinIso: string | null = null;

  private dragState: { active: boolean; mes: string; dia: number; mode: "add" | "remove" } = {
    active: false,
    mes: "",
    dia: 0,
    mode: "add",
  };

  constructor(
    private fb: FormBuilder,
    private translator: Translator,
    private servicioAPI: ConectarApiService,
    private panelService: PanelService,
    private gsCentros: GlobalServicCentros,
    private global: GlobalService,
    private snackvar_service: SnackbarInfoService,
    private httpErrorService: HttpErrorsService,
    private cdRef: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string
  ) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngAfterViewInit(): void {
    this._applyCalendarioColorCssVar(this._cachedColorParaCalendario || "#0000ff");
  }

  private _flagFromApi(value: any): boolean {
    if (value === true) return true;
    if (value === false) return false;
    if (value === 1) return true;
    if (value === 0) return false;
    if (value == null) return false;
    const s = String(value).trim().toLowerCase();
    if (s === "1" || s === "true") return true;
    if (s === "0" || s === "false") return false;
    return false;
  }

  /**
   * Vista previa / leyenda: solo temporadas activas en API (`Activa`).
   * Si el campo no viene, se asume activa (compatibilidad con respuestas antiguas).
   */
  private _esItemActivoParaPreview(item: any): boolean {
    const raw = item?.Activa ?? item?.activa;
    if (raw === undefined || raw === null || String(raw).trim() === "") return true;
    return this._flagFromApi(raw);
  }

  /** Agrupa por color CSS para patrones en la leyenda y un pequeño id en celdas cuando hay colisión. */
  private _colorCssKeyParaAgrupar(css: string | null | undefined): string {
    return (css ?? "").trim().toLowerCase();
  }

  private _asignarDiscriminacionLeyendaPorColor(items: PreviewLeyendaItem[]): void {
    this._coloresDuplicadosEnLeyendaVisible = new Set();
    const byKey = new Map<string, PreviewLeyendaItem[]>();
    for (const it of items) {
      const k = this._colorCssKeyParaAgrupar(it.colorCss);
      if (!byKey.has(k)) byKey.set(k, []);
      byKey.get(k)!.push(it);
    }
    for (const [, group] of byKey) {
      if (group.length <= 1) {
        group[0].leyendaMismoColorQueOtra = false;
        group[0].leyendaVarianteSwatch = 0;
        continue;
      }
      const key = this._colorCssKeyParaAgrupar(group[0].colorCss);
      this._coloresDuplicadosEnLeyendaVisible.add(key);
      group.forEach((it, i) => {
        it.leyendaMismoColorQueOtra = true;
        it.leyendaVarianteSwatch = (i % 5) + 1;
      });
    }
    this.previewVariantePorPk = new Map();
    for (const it of items) {
      this.previewVariantePorPk.set(it.pkId, it.leyendaVarianteSwatch ?? 0);
    }
  }

  /**
   * Alta, edición y duplicado: misma vista (15 meses), colores de otras temporadas, leyenda y reglas de selección.
   */
  usaVistaPreviaCalendario(): boolean {
    return this.mode === "I" || this.mode === "U" || this.mode === "D";
  }

  /** Texto corto «Por Defecto» (recurso `PorDefecto`) para leyenda y tooltips del calendario. */
  private textoPorDefectoLeyenda(): string {
    const t = (this.translation?.PorDefecto ?? "").trim();
    return t || "Por Defecto";
  }

  getPreviewNombreCompletoParaDia(mesKey: string, dia: number): string {
    const iso = this.formatFechaKey(mesKey, dia);
    const pk = this.previewPkPorFecha.get(iso) ?? "";
    return (this.previewNombrePorPk.get(pk) ?? "").trim();
  }

  /** Tooltip en celdas con vista previa: nombre; si es por defecto, «Nombre - Por Defecto». */
  getPreviewTooltipParaDia(mesKey: string, dia: number): string {
    if (this.mostrarPreviewColor(mesKey, dia)) {
      const nombre = this.getPreviewNombreCompletoParaDia(mesKey, dia);
      const titulo = nombre || "?";
      if (this.mostrarPreviewPorDefecto(mesKey, dia)) {
        return `${titulo} - ${this.textoPorDefectoLeyenda()}`;
      }
      return titulo;
    }
    return "";
  }

  /** Accesibilidad: mismo texto que el tooltip + número del día. */
  getPreviewAriaLabelDia(mesKey: string, dia: number): string | null {
    const t = this.getPreviewTooltipParaDia(mesKey, dia);
    return t ? `${t} — ${dia}` : null;
  }

  /** Misma variante que el cuadrado de la leyenda (0 = sólido; 1–5 = patrón si el color está repetido). */
  getPreviewVarianteSwatchParaDia(mesKey: string, dia: number): number {
    if (!this.mostrarPreviewColor(mesKey, dia)) return 0;
    const pk = this.previewPkPorFecha.get(this.formatFechaKey(mesKey, dia)) ?? "";
    return this.previewVariantePorPk.get(pk) ?? 0;
  }

  /** Leyenda: tooltip con nombre; si por defecto, «Nombre - Por Defecto». */
  getLeyendaTooltipItem(it: PreviewLeyendaItem): string {
    const titulo = (it.nombre || "").trim() || "?";
    if (it.porDefecto) {
      return `${titulo} - ${this.textoPorDefectoLeyenda()}`;
    }
    return titulo;
  }

  async ngOnInit(): Promise<void> {
    this.initializeTranslate();
    this.initializeForm();
    this.valuedChanged();
    this.translator.dataLanguage$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.initializeTranslate();
          this.actualizarMesesEntreFechas();
          this.cdRef.markForCheck();
        }
      });
    this.leerTemporadaObligatorioMotivoDesdeLocalStorage();
    await this.loadCentros();
    await this.manageForm(this.pkId, this.mode);
    await this.cargarPreviewTemporadasExistentes();
    this.loading = false;
    this.cdRef.detectChanges();
  }

  async loadCentros() {
    await this.gsCentros.getCentros();
  }

  initializeTranslate() {
    this.translation = this.translator.GetTranslations() || {};
    const t = this.translation;
    const locDual = (this.translator.getLocale() || "es-ES").split("-")[0] || "es";
    this.format = {
      add: t?.Anadir || "Añadir",
      remove: t?.Borrar || "Borrar",
      all: t?.Todos || "Todos",
      none: t?.Ninguno || "Ninguno",
      direction: DualListComponent.LTR,
      draggable: true,
      locale: locDual,
    };
  }

  /** BCP 47 para Intl (meses / cabeceira de días) alineado con el idioma activo del traductor. */
  private localeParaIntl(): string {
    const raw = this.translator?.getLocale?.() || this.localeId || "es-ES";
    return String(raw).replace(/_/g, "-");
  }

  /** Nombres largos de mes (enero…diciembre) según idioma activo. */
  private nombresMesCalendario(): string[] {
    const loc = this.localeParaIntl();
    try {
      return Array.from({ length: 12 }, (_, i) => {
        const d = new Date(Date.UTC(2000, i, 1));
        return new Intl.DateTimeFormat(loc, { month: "long" }).format(d);
      });
    } catch {
      return [...EditTemporadaTarifasComponent._MESES_LABELS_ES];
    }
  }

  /** Iniciales de día L→D (lunes a domingo) para la cabecera de calendarios. */
  get cabeceraDiasSemanaCalendario(): string[] {
    const loc = this.localeParaIntl();
    try {
      const base = new Date(Date.UTC(2024, 0, 1));
      return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(base);
        d.setUTCDate(1 + i);
        return new Intl.DateTimeFormat(loc, { weekday: "narrow" }).format(d);
      });
    } catch {
      return ["L", "M", "X", "J", "V", "S", "D"];
    }
  }

  initializeForm() {
    this.editTemporadaForm = this.fb.group({
      pkId: [""],
      Nombre: ["", [Validators.required, Validators.maxLength(100)]],
      Descripcion: ["", [Validators.maxLength(500), EditTemporadaTarifasComponent.descripcionCaracteresProhibidosValidator]],
      MotivoModificacion: ["", []],
      Color: ["Blue", [Validators.maxLength(9), EditTemporadaTarifasComponent.hexOrNamedColorValidator]],
      Activa: [false],
      PorDefecto: [false],
      FechaInicio: [null, Validators.required],
      FechaFin: [null, Validators.required],
    });
    this._cachedColorParaCalendario = "#0000ff";
  }

  valuedChanged() {
    this.editTemporadaForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.panelService.setDiscardChanges(false);
    });
    this.editTemporadaForm.get("FechaInicio").valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.actualizarMesesEntreFechas();
        this.syncListadoDiasWithRango();
        this._refreshMotivoModificacionValidators();
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
      });
    this.editTemporadaForm.get("FechaFin").valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.actualizarMesesEntreFechas();
        this.syncListadoDiasWithRango();
        this._refreshMotivoModificacionValidators();
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
      });
    this.editTemporadaForm.get("Color").valueChanges
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((color) => {
        this._updateCachedColor(color);
        this.cdRef.markForCheck();
      });
  }

  private getRangoFechasNormalizado(): { inicio: moment.Moment; fin: moment.Moment } | null {
    const ini = this.editTemporadaForm?.get("FechaInicio")?.value;
    const fin = this.editTemporadaForm?.get("FechaFin")?.value;
    if (!ini || !fin) {
      this.rangoFechaInicioIso = null;
      this.rangoFechaFinIso = null;
      return null;
    }
    
    let start: moment.Moment | null = null;
    let end: moment.Moment | null = null;
    
    if (moment.isMoment(ini) && typeof (ini as any).clone === 'function') {
      start = (ini as moment.Moment).clone();
    } else if (ini instanceof Date) {
      start = moment(ini);
    } else if (typeof ini === 'string') {
      start = moment(ini, ['YYYY/MM/DD', 'YYYY/M/D', 'DD/MM/YYYY', 'D/M/YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY'], true);
      if (!start.isValid() && /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}/.test(ini)) {
        start = moment(ini.replace(/\//g, '-'), 'YYYY-MM-DD', true);
      }
    } else {
      start = moment(ini);
    }
    if (moment.isMoment(fin) && typeof (fin as any).clone === 'function') {
      end = (fin as moment.Moment).clone();
    } else if (fin instanceof Date) {
      end = moment(fin);
    } else if (typeof fin === 'string') {
      end = moment(fin, ['YYYY/MM/DD', 'YYYY/M/D', 'DD/MM/YYYY', 'D/M/YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY'], true);
      if (!end.isValid() && /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}/.test(fin)) {
        end = moment(fin.replace(/\//g, '-'), 'YYYY-MM-DD', true);
      }
    } else {
      end = moment(fin);
    }
    
    if (!start || !start.isValid() || !end || !end.isValid() || start.isAfter(end)) {
      this.rangoFechaInicioIso = null;
      this.rangoFechaFinIso = null;
      return null;
    }

    start = start.startOf("day");
    end = end.startOf("day");
    
    this.rangoFechaInicioIso = start.format("YYYY-MM-DD");
    this.rangoFechaFinIso = end.format("YYYY-MM-DD");
    return { inicio: start, fin: end };
  }

  private syncListadoDiasWithRango(options: { markDirty?: boolean } = {}): void {
    const { markDirty = true } = options;
    const rango = this.getRangoFechasNormalizado();
    if (!rango) return;

    const { inicio, fin } = rango;
    const inicioKey = inicio.format("YYYY-MM-DD");
    const finKey = fin.format("YYYY-MM-DD");
    const next = (this.listadoDias || [])
      .map((d) => (!d ? null : this._normalizeDiaIso(d)))
      .filter((iso): iso is string => {
        if (!iso) return false;
        if (this.diasOcupados.has(iso)) return false;
        return iso >= inicioKey && iso <= finKey;
      });

    next.sort();
    const prevKey = (this.listadoDias || []).slice().sort().join("|");
    const nextKey = next.join("|");
    if (prevKey === nextKey) return;

    this.listadoDias = [...next];
    this.listadoDiasSet = new Set(this.listadoDias);
    if (markDirty) {
      this.editTemporadaForm.markAsDirty();
    }
    this.cdRef.markForCheck();
  }

  actualizarMesesEntreFechas() {
    if (!this.editTemporadaForm) return;
    const ini = this.editTemporadaForm.get("FechaInicio")?.value;
    const fin = this.editTemporadaForm.get("FechaFin")?.value;

    this.getRangoFechasNormalizado();

    const mesesLabels = this.nombresMesCalendario();
    const anoVigente = this.getAnoVigente();
    const anoMudou = this.anoVigenteCache !== anoVigente;

    if (anoMudou) {
      this.diasDelMesCache.clear();
      this.diaOffsetCache.clear();
      this.fechaFormatCache.clear();
    }

    /** Rango inclusivo mes a mes (solo si inicio y fin son válidos). */
    this.mesesEntreFechas = [];
    if (ini && fin) {
      const start = this.parseFechaFormValue(ini);
      const end = this.parseFechaFormValue(fin);
      if (start && end && start.isValid() && end.isValid() && !start.isAfter(end)) {
        const rangoMeses: MesInfo[] = [];
        let cur = start.clone().startOf("month");
        const endM = end.clone().startOf("month");
        while (cur.isSameOrBefore(endM, "month")) {
          rangoMeses.push({
            mes: cur.format("YYYY-MM"),
            anio: cur.year(),
            mesNum: cur.month() + 1,
            label: mesesLabels[cur.month()] + " " + cur.year(),
          });
          cur.add(1, "month");
        }
        this.mesesEntreFechas = rangoMeses;
        this.cargarDiasOcupados();
      }
    }

    let dozeMesesDoAno: MesInfo[];
    if (this.usaVistaPreviaCalendario()) {
      if (!this.vista15MesesInicio) {
        this.vista15MesesInicio = moment().startOf("month").subtract(1, "month").clone();
      }
      const windowStart = this.computeInicioVentana15Meses();
      dozeMesesDoAno = this.build15MesesDesde(windowStart);
    } else {
      dozeMesesDoAno = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((mesNum) => ({
        mes: `${anoVigente}-${String(mesNum).padStart(2, "0")}`,
        anio: anoVigente,
        mesNum,
        label: mesesLabels[mesNum - 1] + " " + anoVigente,
      }));
    }
    this.mesesDoAnoVigente = dozeMesesDoAno;
    const chavesAno = dozeMesesDoAno.map((m) => m.mes);
    const chavesStr = chavesAno.join("|");
    if (this._chavesMesesStr !== chavesStr) {
      this.mesVisControls = {};
      this._chavesMesesStr = chavesStr;
    }
    for (const k of chavesAno) {
      this.getMesVisControl(k);
    }

    const rango = this.getRangoFechasNormalizado();
    if (rango) {
      for (const m of dozeMesesDoAno) {
        if (!this.isMesDentroDelRango(m.mes)) continue;
        const ctrl = this.getMesVisControl(m.mes);
        if (ctrl.value === false) {
          ctrl.setValue(true, { emitEvent: false });
        }
      }
    }

    this.mesesSeleccionados = new Set(chavesAno.filter((k) => this.mesVisControls[k]?.value !== false));
    this.anoVigenteCache = anoVigente;
    this.listadoDiasSet = new Set(this.listadoDias);
    this.aplicarFiltroLeyenda();
    this.cdRef.markForCheck();
  }

  /**
   * Início do bloco visual de exatamente 15 meses (grelha de calendário abaixo).
   * O período início–fim nas datas pode ser qualquer duração; esta janela só define quais 15 meses se mostram.
   * Com início e fim válidos: ancorar no mês da data de início. Só fim: últimos 15 meses até ao mês de fim.
   */
  private computeInicioVentana15Meses(): moment.Moment {
    const defStart =
      this.vista15MesesInicio?.clone() ?? moment().startOf("month").subtract(1, "month");
    const ini = this.parseFechaFormValue(this.editTemporadaForm?.get("FechaInicio")?.value);
    const fin = this.parseFechaFormValue(this.editTemporadaForm?.get("FechaFin")?.value);

    if (ini && ini.isValid() && fin && fin.isValid() && !ini.isAfter(fin)) {
      return ini.clone().startOf("month");
    }
    if (ini && ini.isValid()) {
      return ini.clone().startOf("month");
    }
    if (fin && fin.isValid()) {
      return fin.clone().startOf("month").subtract(14, "months");
    }
    return defStart.clone().startOf("month");
  }

  /** 15 meses consecutivos desde el primer día del mes indicado (solo vista). */
  private build15MesesDesde(inicioMes: moment.Moment): MesInfo[] {
    const mesesLabels = this.nombresMesCalendario();
    const out: MesInfo[] = [];
    const start = inicioMes.clone().startOf("month");
    for (let i = 0; i < 15; i++) {
      const cur = start.clone().add(i, "month");
      out.push({
        mes: cur.format("YYYY-MM"),
        anio: cur.year(),
        mesNum: cur.month() + 1,
        label: mesesLabels[cur.month()] + " " + cur.year(),
      });
    }
    return out;
  }

  getMesVisControl(mesKey: string): FormControl {
    if (!this.mesVisControls[mesKey]) {
      const ctrl = new FormControl(true);
      ctrl.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((val) => {
        if (val === false) this.mesesSeleccionados.delete(mesKey);
        else this.mesesSeleccionados.add(mesKey);
        this.aplicarFiltroLeyenda();
        this.cdRef.markForCheck();
      });
      this.mesVisControls[mesKey] = ctrl;
    }
    return this.mesVisControls[mesKey];
  }

  private parseFechaFormValue(val: any): moment.Moment | null {
    if (!val) return null;
    if (moment.isMoment(val) && val.isValid()) return val;
    if (val instanceof Date && !isNaN(val.getTime())) return moment(val);
    if (typeof val === "string") {
      const m = moment(val, ["YYYY/MM/DD", "DD/MM/YYYY", "YYYY-MM-DD", "DD-MM-YYYY"], true);
      return m.isValid() ? m : null;
    }
    return null;
  }

  private getAnoVigente(): number {
    const ini = this.editTemporadaForm?.get("FechaInicio")?.value;
    const parsed = this.parseFechaFormValue(ini);
    return parsed ? parsed.year() : moment().year();
  }

  get minFechaPicker(): Date {
    return moment({
      year: EditTemporadaTarifasComponent._MIN_PICKER_YEAR,
      month: 0,
      day: 1,
    })
      .startOf("day")
      .toDate();
  }

  get maxFechaPicker(): Date {
    return moment({
      year: EditTemporadaTarifasComponent._MAX_PICKER_YEAR,
      month: 11,
      day: 31,
    })
      .endOf("day")
      .toDate();
  }

  /** Início: não depois da data de fim (quando existir). */
  get minFechaInicioPicker(): Date {
    return this.minFechaPicker;
  }

  get maxFechaInicioPicker(): Date {
    const gMax = moment(this.maxFechaPicker);
    const fin = this.parseFechaFormValue(this.editTemporadaForm?.get("FechaFin")?.value);
    if (!fin) return gMax.toDate();
    return moment.min(gMax, fin.clone().endOf("day")).toDate();
  }

  /** Fim: não antes da data de início (quando existir). */
  get minFechaFinPicker(): Date {
    const gMin = moment(this.minFechaPicker);
    const ini = this.parseFechaFormValue(this.editTemporadaForm?.get("FechaInicio")?.value);
    if (!ini) return gMin.toDate();
    return moment.max(gMin, ini.clone().startOf("day")).toDate();
  }

  get maxFechaFinPicker(): Date {
    return this.maxFechaPicker;
  }

  get startAtInicioPicker(): Date {
    const ini = this.editTemporadaForm?.get("FechaInicio")?.value;
    const parsed = this.parseFechaFormValue(ini);
    return parsed ? parsed.toDate() : moment().startOf("day").toDate();
  }

  get startAtFinPicker(): Date {
    const fin = this.editTemporadaForm?.get("FechaFin")?.value;
    const parsed = this.parseFechaFormValue(fin);
    return parsed ? parsed.toDate() : moment().startOf("day").toDate();
  }

  getMesesParaExibir(): MesInfo[] {
    if (this.mesesDoAnoVigente?.length) return this.mesesDoAnoVigente;
    const year = this.getAnoVigente();
    const mesesLabels = this.nombresMesCalendario();
    return mesesLabels.map((nome, i) => ({
      mes: `${year}-${String(i + 1).padStart(2, "0")}`,
      anio: year,
      mesNum: i + 1,
      label: nome + " " + year,
    }));
  }

  getMesesCalendarioVisibles(): MesInfo[] {
    const base = this.mesesDoAnoVigente?.length ? this.mesesDoAnoVigente : this.getMesesParaExibir();
    return base.filter((m) => this.getMesVisControl(m.mes).value !== false);
  }

  tieneRango(): boolean {
    if (!this.editTemporadaForm) return false;
    const ini = this.editTemporadaForm.get("FechaInicio")?.value;
    const fin = this.editTemporadaForm.get("FechaFin")?.value;
    return !!(ini && fin);
  }

  isMesDentroDelRango(mesKey: string): boolean {
    const ini = this.editTemporadaForm.get("FechaInicio").value;
    const fin = this.editTemporadaForm.get("FechaFin").value;
    const inicioParsed = this.parseFechaFormValue(ini);
    const finParsed = this.parseFechaFormValue(fin);
    if (!inicioParsed || !finParsed) return false;
    const inicio = inicioParsed.clone().startOf("month");
    const finRango = finParsed.clone().endOf("month");
    const m = moment(mesKey + "-01", "YYYY-MM-DD", true);
    return m.isValid() && m.isSameOrAfter(inicio) && m.isSameOrBefore(finRango);
  }

  isDiaDentroDelRango(mesKey: string, dia: number): boolean {
    if (!this.rangoFechaInicioIso || !this.rangoFechaFinIso) return false;
    const fecha = this.formatFechaKey(mesKey, dia);
    return fecha >= this.rangoFechaInicioIso && fecha <= this.rangoFechaFinIso;
  }

  cargarDiasOcupados() {
    const ini = this.editTemporadaForm.get("FechaInicio").value;
    const fin = this.editTemporadaForm.get("FechaFin").value;
    if (!ini || !fin) return;
    this.loadingOcupados = true;
    const fechaInicio = this.formatFechaApi(ini);
    const fechaFin = this.formatFechaApi(fin);
    const currentPkId = this.editTemporadaForm.get("pkId").value;
    this.servicioAPI
      .getTemporadaTarifasEntreFechas(fechaInicio, fechaFin)
      .pipe(first())
      .subscribe(
        (data) => {
          this.diasOcupados = new Set();
          const listado = data?.DatosResult?.listado || data?.DatosResult?.Lista || data?.listado || data?.Lista || [];
          (listado || []).forEach((item: any) => {
            const diaRaw = item.Dia ?? item.dia;
            let dia: string | null = null;
            
            if (diaRaw) {
              if (typeof diaRaw === "string") {
                if (/^\d{4}-\d{2}-\d{2}$/.test(diaRaw)) {
                  dia = diaRaw;
                } else {
                  const parsed = moment(diaRaw, ['YYYY/MM/DD', 'YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY'], true);
                  if (parsed.isValid()) {
                    dia = parsed.format("YYYY-MM-DD");
                  }
                }
              } else if (diaRaw instanceof Date) {
                const parsed = moment(diaRaw);
                if (parsed.isValid()) {
                  dia = parsed.format("YYYY-MM-DD");
                }
              }
            }
            
            const tempIdRaw = item.TemporadaTId ?? item.temporadaTId ?? item.TemporadaId ?? 0;
            const tempIdNum = Number(String(tempIdRaw).trim());
            const currentPkIdNum = currentPkId != null && String(currentPkId).trim() !== ""
              ? Number(String(currentPkId).trim())
              : NaN;

            if (
              dia &&
              Number.isFinite(tempIdNum) &&
              tempIdNum !== 0 &&
              (!Number.isFinite(currentPkIdNum) || tempIdNum !== currentPkIdNum)
            ) {
              this.diasOcupados.add(dia);
            }
          });
          this.loadingOcupados = false;
          this.syncListadoDiasWithRango({ markDirty: false });
          this.aplicarFiltroLeyenda();
          this.cdRef.detectChanges();
        },
        () => {
          this.loadingOcupados = false;
          this.aplicarFiltroLeyenda();
          this.cdRef.detectChanges();
        }
      );
  }

  /**
   * Color del campo API `Color` para CSS (hex, rgb, nombre literal como `red` / `Blue`).
   */
  private _colorApiStringToCssBackground(raw: string | null | undefined): string | null {
    const trimmed = (raw ?? "").trim();
    if (!trimmed) return null;
    if (trimmed.startsWith("#") && /^#[0-9A-Fa-f]{3,8}$/.test(trimmed)) {
      return trimmed;
    }
    if (/^rgba?\(/i.test(trimmed) || /^hsla?\(/i.test(trimmed)) {
      return trimmed;
    }
    if (/^[0-9A-Fa-f]{3,8}$/.test(trimmed)) {
      return "#" + trimmed;
    }
    return trimmed;
  }

  /** Nomes CSS comuns (amarelo/derivados) não presentes na paleta do picker. */
  private readonly _namedCssColorToHexExtra: Record<string, string> = {
    yellow: "#ffff00",
    gold: "#ffd700",
    khaki: "#f0e68c",
    lightyellow: "#ffffe0",
    lemonchiffon: "#fffacd",
    palegoldenrod: "#eee8aa",
    chartreuse: "#7fff00",
    greenyellow: "#adff2f",
    yellowgreen: "#9acd32",
    springgreen: "#00ff7f",
    lime: "#00ff00",
    wheat: "#f5deb3",
    cornsilk: "#fff8dc",
    lightgoldenrodyellow: "#fafad2",
    moccasin: "#ffe4b5",
    papayawhip: "#ffefd5",
  };

  private _hexToRgb(hex: string): { r: number; g: number; b: number } | null {
    let h = hex.replace(/^#/, "");
    if (h.length === 8) {
      h = h.slice(0, 6);
    }
    if (h.length === 3) {
      h = h.split("").map((c) => c + c).join("");
    }
    if (h.length !== 6) return null;
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    if ([r, g, b].some((n) => Number.isNaN(n))) return null;
    return { r, g, b };
  }

  private _hslToRgb(h: number, s: number, l: number): { r: number; g: number; b: number } {
    h = ((h % 360) + 360) % 360;
    s = Math.max(0, Math.min(1, s));
    l = Math.max(0, Math.min(1, l));
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const hh = h / 60;
    const x = c * (1 - Math.abs((hh % 2) - 1));
    let r1 = 0;
    let g1 = 0;
    let b1 = 0;
    if (hh < 1) {
      r1 = c;
      g1 = x;
    } else if (hh < 2) {
      r1 = x;
      g1 = c;
    } else if (hh < 3) {
      g1 = c;
      b1 = x;
    } else if (hh < 4) {
      g1 = x;
      b1 = c;
    } else if (hh < 5) {
      r1 = x;
      b1 = c;
    } else {
      r1 = c;
      b1 = x;
    }
    const m = l - c / 2;
    return {
      r: Math.round((r1 + m) * 255),
      g: Math.round((g1 + m) * 255),
      b: Math.round((b1 + m) * 255),
    };
  }

  private _rgbToHsl(r: number, g: number, b: number): { h: number; s: number; l: number } {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h = 0;
    let s = 0;
    if (max !== min) {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
          break;
        case g:
          h = ((b - r) / d + 2) / 6;
          break;
        default:
          h = ((r - g) / d + 4) / 6;
          break;
      }
    }
    return { h: h * 360, s, l };
  }

  /** Converte o valor CSS de fundo da temporada a RGB para heurísticas de contraste. */
  private _parseCssColorToRgb(css: string): { r: number; g: number; b: number } | null {
    const s = (css ?? "").trim();
    if (!s) return null;
    if (s.startsWith("#")) {
      return this._hexToRgb(s);
    }
    const rgbMatch = s.match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i);
    if (rgbMatch) {
      return {
        r: Math.round(Number(rgbMatch[1])),
        g: Math.round(Number(rgbMatch[2])),
        b: Math.round(Number(rgbMatch[3])),
      };
    }
    const hslMatch = s.match(/^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%/i);
    if (hslMatch) {
      return this._hslToRgb(+hslMatch[1], +hslMatch[2] / 100, +hslMatch[3] / 100);
    }
    const lower = s.toLowerCase();
    const fromPalette = this._colorNameToHex[lower];
    if (fromPalette) {
      return this._hexToRgb(fromPalette);
    }
    const namedExtra = this._namedCssColorToHexExtra[lower];
    if (namedExtra) {
      return this._hexToRgb(namedExtra);
    }
    return null;
  }

  /**
   * Estrella blanca solo sobre fondos amarillos/derivados (p. ej. lima, naranja claro) para que no se pierda
   * la estrella amarilla (#fbbf24) sobre el mismo tono.
   */
  private _shouldUseWhiteStarOnSeasonBackground(bgCss: string): boolean {
    const rgb = this._parseCssColorToRgb(bgCss);
    if (!rgb) return false;
    const { r, g, b } = rgb;
    const hsl = this._rgbToHsl(r, g, b);
    const { h, s, l } = hsl;
    if (h >= 30 && h <= 115 && s > 0.1 && l > 0.25) {
      return true;
    }
    if (l > 0.88 && r > 210 && g > 205 && b < 250) {
      return true;
    }
    return false;
  }

  private _colorPreviewDesdeItemApi(item: any): string | null {
    const raw = item?.Color ?? item?.color;
    return this._colorApiStringToCssBackground(raw == null ? "" : String(raw));
  }

  /** Fechas normalizadas del array `listadoDias` de la API (vacíos y "" se ignoran). */
  private listadoDiasValidosDesdeItem(item: any): string[] {
    const rawList = item?.listadoDias ?? item?.ListadoDias ?? [];
    const out: string[] = [];
    if (!Array.isArray(rawList)) return out;
    for (const entry of rawList) {
      const raw = typeof entry === "string" ? entry : entry?.Dia;
      if (raw == null || String(raw).trim() === "") continue;
      const iso = this._normalizeDiaIso(raw);
      if (iso) out.push(iso);
    }
    return out;
  }

  /**
   * Si `listadoDias` solo trae "" o está vacío pero la API define un único día (FechaInicio = FechaFin),
   * usamos ese día (ej. DL2 con listadoDias [""] y 2026/01/31–2026/01/31). No expande rangos largos.
   */
  private fechaUnicaDesdeApiSiListadoVacio(item: any): string | null {
    if (this.listadoDiasValidosDesdeItem(item).length > 0) return null;
    const iniRaw = item?.FechaInicio ?? item?.fechaInicio;
    const finRaw = item?.FechaFin ?? item?.fechaFin;
    if (!iniRaw || !finRaw) return null;
    let a = moment(iniRaw, ["YYYY/MM/DD", "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"], true);
    let b = moment(finRaw, ["YYYY/MM/DD", "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"], true);
    if (!a.isValid()) a = moment(iniRaw);
    if (!b.isValid()) b = moment(finRaw);
    if (!a.isValid() || !b.isValid()) return null;
    a = a.startOf("day");
    b = b.startOf("day");
    if (!a.isSame(b, "day")) return null;
    return a.format("YYYY-MM-DD");
  }

  /** Fechas a pintar: `listadoDias` válidos, o un solo día si listado vacío e inicio=fin. */
  private fechasPreviewDesdeItem(item: any): string[] {
    const fromList = this.listadoDiasValidosDesdeItem(item);
    if (fromList.length > 0) return fromList;
    const u = this.fechaUnicaDesdeApiSiListadoVacio(item);
    return u ? [u] : [];
  }

  /**
   * Al crear temporada nueva: pintar con `Color` + fechas de `listadoDias` (y fallback día único inicio=fin).
   * Mismo día en varias temporadas: gana mayor pkId. Fechas en otro año (p. ej. 2027) solo se ven al
   * mostrar esos meses/año en el calendario. Rangos anuales sin días en listado (DL7–10 con [""]) no se pintan.
   */
  private buildPreviewLeyenda(sorted: any[]): PreviewLeyendaItem[] {
    const out: PreviewLeyendaItem[] = [];
    for (const item of sorted) {
      if (!this._esItemActivoParaPreview(item)) continue;
      const cssColor = this._colorPreviewDesdeItemApi(item);
      if (cssColor == null) continue;
      const fechas = this.fechasPreviewDesdeItem(item);
      if (fechas.length === 0) continue;
      const nombre = String(item?.Nombre ?? item?.nombre ?? "").trim();
      out.push({
        pkId: String(item?.pkId ?? ""),
        nombre: nombre || `#${item?.pkId ?? "?"}`,
        colorCss: cssColor,
        porDefecto: this._flagFromApi(item?.PorDefecto ?? item?.porDefecto),
        fechasPreview: fechas,
      });
    }
    return out;
  }

  /**
   * Leyenda: solo temporadas que **realmente se pintan** en la vista del usuario:
   * - Con **fecha inicio y fin** válidas: solo días dentro de ese rango (misma ventana que el formulario).
   * - Mes con casilla visible (no oculto).
   * - Ese día gana el color en `previewPkPorFecha` (misma regla que las celdas).
   */
  private aplicarFiltroLeyenda(): void {
    if (!this.usaVistaPreviaCalendario()) {
      this.previewLeyenda = [];
      this._coloresDuplicadosEnLeyendaVisible = new Set();
      this.previewVariantePorPk = new Map();
      return;
    }
    this.getRangoFechasNormalizado();
    const iniR = this.rangoFechaInicioIso;
    const finR = this.rangoFechaFinIso;
    const filtrarPorRangoFechas = !!(iniR && finR);

    const fuente = this.previewLeyendaFuente;
    if (!fuente.length) {
      this.previewLeyenda = [];
      this._coloresDuplicadosEnLeyendaVisible = new Set();
      this.previewVariantePorPk = new Map();
      return;
    }
    const mesesVisibles = new Set(this.getMesesCalendarioVisibles().map((m) => m.mes));
    const pkGanador = this.previewPkPorFecha;
    const seenPk = new Set<string>();
    const out: PreviewLeyendaItem[] = [];
    for (const it of fuente) {
      const seVeEnPantalla = it.fechasPreview.some((iso) => {
        if (filtrarPorRangoFechas && (iso < iniR || iso > finR)) {
          return false;
        }
        const mk = iso.length >= 7 ? iso.slice(0, 7) : "";
        if (!mk || !mesesVisibles.has(mk)) return false;
        return pkGanador.get(iso) === it.pkId;
      });
      if (!seVeEnPantalla) continue;
      if (seenPk.has(it.pkId)) continue;
      seenPk.add(it.pkId);
      out.push(it);
    }
    this._asignarDiscriminacionLeyendaPorColor(out);
    this.previewLeyenda = out;
  }

  trackByLeyendaPk(_index: number, it: PreviewLeyendaItem): string {
    return it.pkId;
  }

  /**
   * Carga **toda** la respuesta de GetTemporadaTarifas (`filters: []`, hasta `pagelements`):
   * cada `listadoDias` válido de temporadas **activas** (`Activa`) entra en `previewColorPorFecha` /
   * `previewPkPorFecha` (misma fecha: gana el último pkId en orden ascendente). La **vista** (meses en
   * checkbox, rango inicio/fin) solo filtra qué celdas se pintan y la leyenda (`aplicarFiltroLeyenda`);
   * no se recorta el payload en la petición.
   * Orden: primero `mesesDoAnoVigente` vía `actualizarMesesEntreFechas`, luego leyenda coherente con lo visible.
   */
  async cargarPreviewTemporadasExistentes(): Promise<void> {
    this.loadingPreviewTemporadas = true;
    this.previewColorPorFecha = new Map();
    this.previewPorDefectoPorFecha = new Map();
    this.previewPkPorFecha = new Map();
    this.previewNombrePorPk = new Map();
    this.previewVariantePorPk = new Map();
    this.previewLeyenda = [];
    this.previewLeyendaFuente = [];
    try {
      const paginator = { page: 1, pagelements: 500, orderby: "pkId", ordertype: "ASC" as const };
      const data = await this.servicioAPI.getTemporadaTarifasAsync(paginator, []);
      const listado = data?.DatosResult?.listado || data?.DatosResult?.Lista || [];
      const sorted = (Array.isArray(listado) ? [...listado] : []).sort(
        (a: any, b: any) => Number(a?.pkId) - Number(b?.pkId)
      );
      const map = new Map<string, string>();
      const porDefMap = new Map<string, boolean>();
      const pkMap = new Map<string, string>();
      const nombrePorPk = new Map<string, string>();
      for (const item of sorted) {
        if (!this._esItemActivoParaPreview(item)) continue;
        const cssColor = this._colorPreviewDesdeItemApi(item);
        if (cssColor == null) continue;
        const porDef = this._flagFromApi(item?.PorDefecto ?? item?.porDefecto);
        const pkId = String(item?.pkId ?? "");
        const nombre = String(item?.Nombre ?? item?.nombre ?? "").trim();
        if (pkId) nombrePorPk.set(pkId, nombre);
        for (const f of this.fechasPreviewDesdeItem(item)) {
          map.set(f, cssColor);
          porDefMap.set(f, porDef);
          pkMap.set(f, pkId);
        }
      }
      this.previewColorPorFecha = map;
      this.previewPorDefectoPorFecha = porDefMap;
      this.previewPkPorFecha = pkMap;
      this.previewNombrePorPk = nombrePorPk;
      this.previewLeyendaFuente = this.buildPreviewLeyenda(sorted);
      this.actualizarMesesEntreFechas();
    } catch (e) {
      this.httpErrorService.identificarErrores(e);
    } finally {
      this.loadingPreviewTemporadas = false;
      this.cdRef.markForCheck();
    }
  }

  mostrarPreviewColor(mesKey: string, dia: number): boolean {
    if (!this.usaVistaPreviaCalendario()) return false;
    return this.previewColorPorFecha.has(this.formatFechaKey(mesKey, dia));
  }

  /** Fecha ocupada por otra temporada (GetTemporadaTarifasEntreFechas). */
  isDiaBloqueadoParaSeleccion(mesKey: string, dia: number): boolean {
    return this.isDiaOcupado(mesKey, dia);
  }

  getPreviewColorCss(mesKey: string, dia: number): string | null {
    return this.previewColorPorFecha.get(this.formatFechaKey(mesKey, dia)) ?? null;
  }

  /** Estrella en celda: día de vista previa perteneciente a temporada PorDefecto (según API, último pkId gana). */
  mostrarPreviewPorDefecto(mesKey: string, dia: number): boolean {
    if (!this.usaVistaPreviaCalendario()) return false;
    return this.previewPorDefectoPorFecha.get(this.formatFechaKey(mesKey, dia)) === true;
  }

  /** Color de la estrella de PorDefecto: ámbar por defecto; blanco si el fondo de temporada es amarillo/derivado. */
  getPreviewStarColorCss(mesKey: string, dia: number): string {
    if (!this.mostrarPreviewPorDefecto(mesKey, dia)) return "#fbbf24";
    const bg = this.getPreviewColorCss(mesKey, dia);
    if (!bg) return "#fbbf24";
    return this._shouldUseWhiteStarOnSeasonBackground(bg) ? "#ffffff" : "#fbbf24";
  }

  previewStarEsBlanca(mesKey: string, dia: number): boolean {
    return this.getPreviewStarColorCss(mesKey, dia) === "#ffffff";
  }

  /**
   * Atenúa meses fuera del rango inicio/fin cuando ya hay rango; sin rango en alta, no atenuar si hay preview
   * (mejor visibilidad de temporadas existentes).
   */
  isMesCalendarioAtenuado(mesKey: string): boolean {
    if (this.isMesDentroDelRango(mesKey)) return false;
    if (this.usaVistaPreviaCalendario() && !this.tieneRango() && !this.loadingPreviewTemporadas) return false;
    return true;
  }

  getMesesSeleccionados() {
    return (this.mesesEntreFechas || []).filter((m) => this.mesesSeleccionados.has(m.mes));
  }

  trackByMesKey(_index: number, m: { mes: string; anio: number; mesNum: number; label: string }): string {
    return m.mes;
  }

  onColorPickerChange(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    if (!val) return;
    
    this._updateCachedColor(val);
    
    if (this.isDraggingColor) {
      return;
    } else {
      const ctrl = this.editTemporadaForm.get("Color");
      if (ctrl.value !== val) {
        ctrl.setValue(val, { emitEvent: true });
      }
      this.cdRef.markForCheck();
    }
  }

  onColorPickerMouseDown(event: MouseEvent) {
    this.isDraggingColor = true;
  }

  onColorPickerMouseUp(event: MouseEvent) {
    if (this.isDraggingColor) {
      const val = (event.target as HTMLInputElement)?.value;
      if (val) {
        const ctrl = this.editTemporadaForm.get("Color");
        if (ctrl.value !== val) {
          ctrl.setValue(val, { emitEvent: true });
        }
        this._updateCachedColor(val);
        this.cdRef.markForCheck();
      }
      this.isDraggingColor = false;
    }
  }

  private _applyCalendarioColorCssVar(color: string): void {
    const el = this.calendariosRoot?.nativeElement;
    if (!el) return;
    el.style.setProperty("--temporada-color", color || "#0000ff");
  }

  private _updateCachedColor(color: string | null): void {
    const trimmed = (color || "").trim();
    let result = "#0000ff";
    if (!trimmed) {
      result = "#0000ff";
    } else if (this._colorNameToHex[trimmed.toLowerCase()]) {
      result = this._colorNameToHex[trimmed.toLowerCase()];
    } else if (trimmed.startsWith("#") && /^#[0-9A-Fa-f]{3,8}$/.test(trimmed)) {
      result = trimmed;
    } else if (trimmed.startsWith("rgb")) {
      result = trimmed;
    } else if (/^[0-9A-Fa-f]{3,8}$/.test(trimmed)) {
      result = "#" + trimmed;
    }
    if (this._cachedColorParaCalendario !== result) {
      this._cachedColorParaCalendario = result;
      this._applyCalendarioColorCssVar(result);
    }
  }

  get colorParaCalendario(): string {
    return this._cachedColorParaCalendario;
  }

  /** Rótulo traduzido da paleta (`ColorPalette_*` nos ficheiros de idiomas). */
  paletteLabel(c: { value: string; label: string; labelKey: string }): string {
    const t = this.translation as Record<string, string> | undefined;
    const k = c.labelKey;
    if (t && typeof t[k] === "string") {
      const s = t[k].trim();
      if (s) return s;
    }
    return c.label;
  }

  
  get coresDisponiveisOrdenadas(): Array<{
    value: string;
    label: string;
    labelKey: string;
    hex: string;
  }> {
    const loc = (this.localeId || "en").replace(/_/g, "-");
    return [...this.coresDisponiveis].sort((a, b) =>
      this.paletteLabel(a).localeCompare(this.paletteLabel(b), loc, {
        sensitivity: "base",
        numeric: true,
      })
    );
  }

  get colorSelectValue(): string {
    const raw = (this.editTemporadaForm?.get("Color")?.value || "").toString().trim();
    if (!raw) return "Blue";
    const lower = raw.toLowerCase();
    const match = this.coresDisponiveis.find((c) => c.value.toLowerCase() === lower);
    return match ? match.value : "__custom__";
  }

  get isCustomColor(): boolean {
    return this.colorSelectValue === "__custom__";
  }

  onColorSelectChange(value: string): void {
    const ctrl = this.editTemporadaForm?.get("Color");
    if (!ctrl) return;
    if (value === "__custom__") {
      const current = (ctrl.value || "").toString().trim();
      const keep = current.startsWith("#") ? current : this._cachedColorParaCalendario || "#0000ff";
      ctrl.setValue(keep, { emitEvent: true });
      return;
    }
    ctrl.setValue(value, { emitEvent: true });
  }

  getDiasDelMes(mesKey: string): number[] {
    if (this.diasDelMesCache.has(mesKey)) {
      return this.diasDelMesCache.get(mesKey)!;
    }
    const parts = mesKey.split("-").map(Number);
    const y = parts[0], m = parts[1];
    if (isNaN(y) || isNaN(m) || m < 1 || m > 12) {
      return [];
    }
    const dateStr = `${y}-${String(m).padStart(2, "0")}-01`;
    const m2 = moment(dateStr, "YYYY-MM-DD", true);
    const dias = m2.isValid() ? m2.daysInMonth() : 31;
    const result = Array.from({ length: dias }, (_, i) => i + 1);
    this.diasDelMesCache.set(mesKey, result);
    return result;
  }

  getDiaOffset(mesKey: string): number {
    if (this.diaOffsetCache.has(mesKey)) {
      return this.diaOffsetCache.get(mesKey)!;
    }
    const parts = mesKey.split("-").map(Number);
    const y = parts[0], m = parts[1];
    if (isNaN(y) || isNaN(m) || m < 1 || m > 12) {
      return 0;
    }
    const dateStr = `${y}-${String(m).padStart(2, "0")}-01`;
    const m2 = moment(dateStr, "YYYY-MM-DD", true);
    const result = m2.isValid() ? m2.isoWeekday() - 1 : 0;
    this.diaOffsetCache.set(mesKey, result);
    return result;
  }
  

  private formatFechaKey(mesKey: string, dia: number): string {
    const key = `${mesKey}-${dia}`;
    if (this.fechaFormatCache.has(key)) {
      return this.fechaFormatCache.get(key)!;
    }
    const fechaStr = `${mesKey}-${String(dia).padStart(2, "0")}`;
    const fecha = moment(fechaStr, "YYYY-MM-DD", true).format("YYYY-MM-DD");
    this.fechaFormatCache.set(key, fecha);
    return fecha;
  }

  isDiaOcupado(mesKey: string, dia: number): boolean {
    const fecha = this.formatFechaKey(mesKey, dia);
    return this.diasOcupados.has(fecha);
  }

  isDiaSeleccionado(mesKey: string, dia: number): boolean {
    const fecha = this.formatFechaKey(mesKey, dia);
    return this.listadoDiasSet.has(fecha);
  }
  
  trackByDiaKey(_index: number, dia: number): number {
    return dia;
  }

  @HostListener("document:pointerup")
  onDocumentMouseUp() {
    this.dragState.active = false;
  }

  private addDia(mesKey: string, dia: number): void {
    const fechaStr = `${mesKey}-${String(dia).padStart(2, "0")}`;
    const fecha = moment(fechaStr, "YYYY-MM-DD", true).isValid()
      ? moment(fechaStr, "YYYY-MM-DD", true).format("YYYY-MM-DD") : fechaStr;
    const ocupado = this.diasOcupados.has(fecha);
    const yaIncluido = this.listadoDiasSet.has(fecha);
    if (ocupado || yaIncluido) {
      return;
    }
    this.listadoDiasSet.add(fecha);
    this.listadoDias.push(fecha);
  }

  private removeDia(mesKey: string, dia: number): void {
    const fechaStr = `${mesKey}-${String(dia).padStart(2, "0")}`;
    const fecha = moment(fechaStr, "YYYY-MM-DD", true).isValid()
      ? moment(fechaStr, "YYYY-MM-DD", true).format("YYYY-MM-DD") : fechaStr;
    const idx = this.listadoDias.indexOf(fecha);
    if (idx >= 0) {
      this.listadoDias.splice(idx, 1);
      this.listadoDiasSet.delete(fecha);
    }
  }

  private aplicarDia(mesKey: string, dia: number, mode: "add" | "remove"): void {
    this.calendarioTouched = true;
    const fechaStr = `${mesKey}-${String(dia).padStart(2, "0")}`;
    const fecha = moment(fechaStr, "YYYY-MM-DD", true).isValid()
      ? moment(fechaStr, "YYYY-MM-DD", true).format("YYYY-MM-DD") : fechaStr;
    if (mode === "add") this.addDia(mesKey, dia);
    else this.removeDia(mesKey, dia);
    this.panelService.setDiscardChanges(false);
    this.editTemporadaForm.markAsDirty();
  }

  marcarDesdeDiaHastaFinMes(mesKey: string, dia: number): void {
    this.calendarioTouched = true;
    const parts = mesKey.split("-").map(Number);
    const y = parts[0], m = parts[1];
    if (isNaN(y) || isNaN(m) || m < 1 || m > 12) return;
    const dateStr = `${y}-${String(m).padStart(2, "0")}-01`;
    const m2 = moment(dateStr, "YYYY-MM-DD", true);
    const ultimoDia = m2.isValid() ? m2.daysInMonth() : 31;
    for (let d = dia; d <= ultimoDia; d++) {
      if (this.isDiaDentroDelRango(mesKey, d)) this.addDia(mesKey, d);
    }
    this.panelService.setDiscardChanges(false);
  }

  private lastPointerDown = { mes: "", dia: 0, t: 0 };

  private handleDiaPress(mesKey: string, dia: number) {
    const ocupado = this.isDiaBloqueadoParaSeleccion(mesKey, dia);
    const enRango = this.isDiaDentroDelRango(mesKey, dia);
    if (ocupado || !enRango) return;
    this.lastPointerDown = { mes: mesKey, dia, t: Date.now() };
    const estaSeleccionado = this.isDiaSeleccionado(mesKey, dia);
    this.aplicarDia(mesKey, dia, estaSeleccionado ? "remove" : "add");
    this.dragState = { active: true, mes: mesKey, dia, mode: estaSeleccionado ? "remove" : "add" };
  }

  onDiaClick(mesKey: string, dia: number) {
    const ocupado = this.isDiaBloqueadoParaSeleccion(mesKey, dia);
    const enRango = this.isDiaDentroDelRango(mesKey, dia);
    const skipPorPointer = this.lastPointerDown.mes === mesKey && this.lastPointerDown.dia === dia && Date.now() - this.lastPointerDown.t < 300;
    if (ocupado || !enRango) return;
    if (skipPorPointer) return;
    const estaSeleccionado = this.isDiaSeleccionado(mesKey, dia);
    this.aplicarDia(mesKey, dia, estaSeleccionado ? "remove" : "add");
  }

  onDiaPointerDown(mesKey: string, dia: number, _event?: PointerEvent) {
    this.handleDiaPress(mesKey, dia);
  }

  onDiaMouseDown(mesKey: string, dia: number) {
    const recentlyHandled =
      this.lastPointerDown.mes === mesKey &&
      this.lastPointerDown.dia === dia &&
      Date.now() - this.lastPointerDown.t < 300;
    if (recentlyHandled) return;
    this.handleDiaPress(mesKey, dia);
  }

  onDiaMouseEnter(mesKey: string, dia: number) {
    if (!this.dragState.active) return;
    if (mesKey !== this.dragState.mes) return;
    if (this.isDiaBloqueadoParaSeleccion(mesKey, dia) || !this.isDiaDentroDelRango(mesKey, dia)) return;
    this.aplicarDia(mesKey, dia, this.dragState.mode);
  }

  async manageForm(pkId: string, mode: Mode) {
    if (mode === "I") {
      this.centrosAsignados = [];
      this.centrosSinAsignar = (this.gsCentros.tipoCentros || []).filter(
        (c: any) => c.Activo === "True" || c.Activo === true
      );
      this.vista15MesesInicio = moment().startOf("month").subtract(1, "month");
      this._chavesMesesStr = null;
      this.editTemporadaForm.patchValue(
        {
          pkId: "",
          Activa: false,
          PorDefecto: false,
          FechaInicio: null,
          FechaFin: null,
        },
        { emitEvent: false }
      );
      this.editTemporadaForm.get("MotivoModificacion")?.setValue("", { emitEvent: false });
      this._fechasTemporadaOriginales = null;
      this._refreshMotivoModificacionValidators();
      return;
    }
    this.vista15MesesInicio = null;
    if (pkId) {
      await this.cargarTemporada(pkId, mode);
    }
  }

  async cargarTemporada(pkId: string, mode: Mode) {
    try {
      const paginator = { page: 1, pagelements: 1, orderby: "pkId", ordertype: "ASC" };
      const data = await this.servicioAPI.getTemporadaTarifasAsync(paginator, [], pkId);
      const listado = data?.DatosResult?.listado || data?.DatosResult?.Lista || [];
      const item = Array.isArray(listado) && listado.length ? listado[0] : null;
      if (item) {
        const colorValue = item.Color || "#0000ff";
        
        const parseFecha = (fecha: any): Date | null => {
          if (!fecha) return null;
          const formats = ["YYYY/MM/DD", "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"];
          for (const fmt of formats) {
            const parsed = moment(fecha, fmt, true);
            if (parsed.isValid()) {
              return parsed.toDate();
            }
          }
          const autoParsed = moment(fecha);
          return autoParsed.isValid() ? autoParsed.toDate() : null;
        };
        
        this.editTemporadaForm.patchValue({
          pkId: item.pkId,
          Nombre: item.Nombre || "",
          Descripcion: (item.Descripcion || "").trim(),
          Color: colorValue,
          Activa: this._flagFromApi(item.Activa),
          PorDefecto: this._flagFromApi(item.PorDefecto),
          FechaInicio: parseFecha(item.FechaInicio),
          FechaFin: parseFecha(item.FechaFin),
        });
        this._updateCachedColor(colorValue);
        if (mode === "D") {
          this.editTemporadaForm.get("pkId").setValue("");
          this.editTemporadaForm.get("Color").setValue("Blue");
          this._updateCachedColor("Blue");
          this.listadoDias = [];
          this.listadoDiasSet = new Set();
          this.calendarioTouched = false;
        } else {
          const dias = item.listadoDias || item.ListadoDias || [];
          this.listadoDias = Array.isArray(dias)
            ? dias
                .map((d: any) => {
                  const raw = typeof d === "string" ? d : d?.Dia;
                  if (!raw || raw.trim() === "") return null;
                  const formats = ["YYYY/MM/DD", "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"];
                  for (const fmt of formats) {
                    const parsed = moment(raw, fmt, true);
                    if (parsed.isValid()) {
                      return parsed.format("YYYY-MM-DD");
                    }
                  }
                  const autoParsed = moment(raw);
                  return autoParsed.isValid() ? autoParsed.format("YYYY-MM-DD") : null;
                })
                .filter((d: string | null): d is string => d !== null && d !== "")
            : [];
          this.listadoDiasSet = new Set(this.listadoDias);
          this.calendarioTouched = this.listadoDias.length > 0;
        }
        const centrosIds = item.CentrosIds || item.centrosIds || "";
        this.centrosAsignados = this.gsCentros.daTiposCentros({
          CentrosIds: centrosIds,
          centrosIds: centrosIds,
        }) || [];
        const all = (this.gsCentros.tipoCentros || []).filter(
          (c: any) => c.Activo === "True" || c.Activo === true
        );
        // IMPORTANTE: o customan-dual-list (angular-dual-listbox) consegue derivar
        // "disponíveis" vs "atribuídos" a partir do source + destination.
        // Se enviarmos o source já subtraindo os atribuídos e, por exemplo,
        // todos os centros estiverem atribuídos, o source fica vazio e o componente
        // pode não renderizar a lista da direita corretamente (itens ficam "invisíveis").
        // Portanto mantemos o source como a lista completa de centros ativos.
        this.centrosSinAsignar = all;
        this.actualizarMesesEntreFechas();
        this.syncListadoDiasWithRango({ markDirty: false });

        this.editTemporadaForm.get("MotivoModificacion")?.setValue("", { emitEvent: false });
        if (mode === "U") {
          this._fechasTemporadaOriginales = this._fechasSnapshotFromForm();
        } else {
          this._fechasTemporadaOriginales = null;
        }
        this._refreshMotivoModificacionValidators();
      }
    } catch (error) {
      this.httpErrorService.identificarErrores(error);
    }
  }

  validateFields(field: string): boolean {
    const c = this.editTemporadaForm.get(field);
    return c && c.invalid && (c.dirty || c.touched);
  }

  getErrorMessage(field: string): string {
    const c = this.editTemporadaForm.get(field);
    if (!c || !c.errors) return "";
    if (c.errors.required) {
      if (field === "MotivoModificacion") {
        return (
          this.translation?.MotivoModificacionRequerido ||
          this.translation?.CampoRequerido ||
          "Campo requerido"
        );
      }
      return this.translation?.CampoRequerido || "Campo requerido";
    }
    if (c.errors.maxlength) {
      const pref =
        this.translation?.MaxCaracteres ||
        this.translation?.Maximo ||
        "Máx.";
      return `${pref} ${c.errors.maxlength.requiredLength}`;
    }
    if (c.errors.invalidHexColor) {
      return (
        this.translation?.ColorHexInvalido ||
        "Introduzca un color hexadecimal válido (#RGB, #RRGGBB o #RRGGBBAA)."
      );
    }
    if (c.errors.descripcionCaracteresProhibidos) {
      const seq = c.errors.descripcionCaracteresProhibidos.secuencia;
      const msg =
        this.translation?.DescripcionCaracteresProhibidos ||
        'No se permiten las secuencias: -- ; /* */ @@. Fragmento bloqueado: ';
      return `${msg}"${seq}"`;
    }
    return "";
  }

  onMotivoModificacionInput(event: Event): void {
    const input = event.target as HTMLTextAreaElement;
    const valor = input.value ?? "";
    const sanitizado = EditTemporadaTarifasComponent.sanitizarDescripcion(valor);
    if (sanitizado !== valor) {
      const ctrl = this.editTemporadaForm.get("MotivoModificacion");
      if (ctrl) {
        ctrl.setValue(sanitizado, { emitEvent: true });
        input.value = sanitizado;
      }
    }
  }

  private _fechasSnapshotFromForm(): { inicio: string; fin: string } {
    const norm = (v: any): string => {
      if (v == null || v === "") return "";
      let m: moment.Moment;
      if (moment.isMoment(v)) {
        m = v.clone().startOf("day");
      } else if (v instanceof Date) {
        m = moment(v).startOf("day");
      } else {
        m = moment(v, ["YYYY/MM/DD", "YYYY/M/D", "DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD", "DD-MM-YYYY"], true);
        if (!m.isValid()) {
          m = moment(v);
        }
        m = m.startOf("day");
      }
      return m.isValid() ? m.format("YYYY-MM-DD") : "";
    };
    const fi = this.editTemporadaForm?.get("FechaInicio")?.value;
    const ff = this.editTemporadaForm?.get("FechaFin")?.value;
    return { inicio: norm(fi), fin: norm(ff) };
  }

  private _fechasTemporadaCambiaron(): boolean {
    if (this.mode !== "U" || !this._fechasTemporadaOriginales) {
      return false;
    }
    const cur = this._fechasSnapshotFromForm();
    const o = this._fechasTemporadaOriginales;
    return cur.inicio !== o.inicio || cur.fin !== o.fin;
  }


  private _esTemporadaObligatorioMotivoConfig(raw: unknown): boolean {
    if (raw === undefined || raw === null) {
      return false;
    }
    if (raw === 1) {
      return true;
    }
    const s = String(raw).trim();
    return s === "1";
  }

  private leerTemporadaObligatorioMotivoDesdeLocalStorage(): void {
    this.obligarMotivoModificacionAppConfig = false;
    try {
      const raw = localStorage.getItem("TemporadaObligatorioMotivoModificacion");
      if (raw == null || raw === "") {
        return;
      }
      this.obligarMotivoModificacionAppConfig = this._esTemporadaObligatorioMotivoConfig(
        raw
      );
    } catch {
      this.obligarMotivoModificacionAppConfig = false;
    }
  }

  get motivoModificacionEsObligatorio(): boolean {
    if (this.mode !== "U") {
      return false;
    }
    return this.obligarMotivoModificacionAppConfig || this._fechasTemporadaCambiaron();
  }

  private _refreshMotivoModificacionValidators(): void {
    const ctrl = this.editTemporadaForm?.get("MotivoModificacion");
    if (!ctrl) {
      return;
    }
    if (this.mode !== "U") {
      ctrl.clearValidators();
      ctrl.updateValueAndValidity({ emitEvent: false });
      return;
    }
    const forbidden = EditTemporadaTarifasComponent.descripcionCaracteresProhibidosValidator;
    const base = [Validators.maxLength(500), forbidden];
    if (this.motivoModificacionEsObligatorio) {
      ctrl.setValidators([Validators.required, ...base]);
    } else {
      ctrl.setValidators([...base]);
    }
    ctrl.updateValueAndValidity({ emitEvent: false });
  }

  /** Bloquea en el campo Descripción las secuencias prohibidas por la API: -- ; slash-star slash-star @@ */
  onDescripcionInput(event: Event): void {
    const input = event.target as HTMLTextAreaElement;
    const valor = input.value ?? "";
    const sanitizado = EditTemporadaTarifasComponent.sanitizarDescripcion(valor);
    if (sanitizado !== valor) {
      const ctrl = this.editTemporadaForm.get("Descripcion");
      if (ctrl) {
        ctrl.setValue(sanitizado, { emitEvent: true });
        input.value = sanitizado;
      }
    }
  }

  /** Restringe el input del campo Color (modo personalizado) a solo caracteres hexadecimales. */
  onHexColorInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = (input.value || "").trim();
    const hasHash = value.startsWith("#");
    const rest = hasHash ? value.slice(1) : value;
    const hexOnly = rest.replace(/[^0-9A-Fa-f]/g, "");
    const maxLen = 8;
    const truncated = hexOnly.slice(0, maxLen);
    const newValue = hasHash ? "#" + truncated : (truncated ? "#" + truncated : "");
    if (newValue !== value) {
      const ctrl = this.editTemporadaForm.get("Color");
      if (ctrl) {
        ctrl.setValue(newValue, { emitEvent: true });
        input.value = newValue;
      }
    }
  }

  private formatFechaApi(value: any): string {
    if (value == null || value === "") return "";
    const m = moment(value);
    return m.isValid() ? m.format("YYYY/MM/DD") : "";
  }

 
  private _normalizeDiaIso(value: any): string | null {
    if (value == null) return null;
    if (typeof value !== "string") {
      const m = moment(value);
      return m.isValid() ? m.format("YYYY-MM-DD") : null;
    }
    const s = value.trim();
    if (!s) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    if (/^\d{4}\/\d{2}\/\d{2}$/.test(s)) {
      const m = moment(s, "YYYY/MM/DD", true);
      return m.isValid() ? m.format("YYYY-MM-DD") : null;
    }
    const m = moment(s, ["YYYY-MM-DD", "YYYY/MM/DD", moment.ISO_8601], true);
    return m.isValid() ? m.format("YYYY-MM-DD") : null;
  }

  submit() {
    this.editTemporadaForm.markAllAsTouched();
    if (this.editTemporadaForm.invalid) return;
    const f = this.editTemporadaForm.getRawValue() as any;
    const descripcion = EditTemporadaTarifasComponent.sanitizarDescripcion(
      (f.Descripcion || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n").trim()
    );
    const motivoRaw = (f.MotivoModificacion || "")
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .trim();
    const motivoSanitizado = EditTemporadaTarifasComponent.sanitizarDescripcion(motivoRaw);
    const rawColor = (f.Color || "").trim();
    let colorToSend = rawColor;
    const isNamedColor = !!(colorToSend && this._colorNameToHex[colorToSend.toLowerCase()]);
    if (!colorToSend) {
      colorToSend = "Blue";
    } else if (!isNamedColor) {
      if (colorToSend && !colorToSend.startsWith("#") && !colorToSend.startsWith("rgb")) {
        colorToSend = "#" + colorToSend;
      }
    }
    const CentrosIds = this.gsCentros.obtenercentrosAsociadosconOrden(this.centrosAsignados);

    const diasConflitantes = (this.listadoDias || []).filter((d) => {
      const iso = this._normalizeDiaIso(d);
      if (!iso) return false;
      return this.diasOcupados?.has(iso) === true;
    });
    if (diasConflitantes.length) {
      const msg =
        (this.translation?.FechasOcupadas ||
          "Las siguientes fechas ya están vinculadas a otra temporada:") +
        " " +
        diasConflitantes
          .slice()
          .sort()
          .slice(0, 12)
          .map((d) => {
            const iso = this._normalizeDiaIso(d);
            return iso ? moment(iso, "YYYY-MM-DD").format("YYYY/MM/DD") : String(d);
          })
          .join(", ") +
        (diasConflitantes.length > 12 ? "..." : "");
      this.snackvar_service.openSnackBar(msg, "", "red-snackbar");
      return;
    }

    const body: any = {
      Nombre: (f.Nombre || "").trim(),
      Descripcion: descripcion,
      Color: colorToSend,
      Activa: f.Activa ? "1" : "0",
      PorDefecto: f.PorDefecto ? "1" : "0",
      FechaInicio: f.FechaInicio ? this.formatFechaApi(f.FechaInicio) : null,
      FechaFin: f.FechaFin ? this.formatFechaApi(f.FechaFin) : null,
      CentrosIds: CentrosIds || "",
      listadoDias: [...this.listadoDias].sort().map((d) => this.formatFechaApi(d)),
      MotivoModificacion: motivoSanitizado,
    };
    if (this.mode === "U" && f.pkId) {
      body.pkId = String(f.pkId);
    }
    this.loading = true;
    const save$ =
      this.mode === "U"
        ? this.servicioAPI.updTemporadaTarifas(body)
        : this.servicioAPI.insTemporadaTarifas(body);

    save$
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data?.DatosResult != null) {
            this.snackvar_service.openSnackBar(
              this.translation?.DatosGuardadosCorrectamente || "Datos guardados correctamente",
              "",
              "green-snackbar"
            );
            this.panelService.setSavePanel(null);
            this.panelService.setClosePanel(null);
          } else if (data?.Mensajes?.length) {
            this.snackvar_service.openSnackBar(
              data.Mensajes[0].DescripcionMensaje,
              "",
              "red-snackbar"
            );
          }
        },
        (error) => {
          this.loading = false;
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  discard() {
    void (async () => {
      await this.manageForm(this.pkId, this.mode);
      await this.cargarPreviewTemporadasExistentes();
      this.cdRef.markForCheck();
    })();
  }
}
